import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import Login from './pages/Login';
import Portal from './pages/Portal';
import { useAuth } from './core/contexts/authContext';
import './App.scss';
import ScoreboardPage from 'pages/Scoreboard';

const AppRoutes = () => {
  const { user, token, isInitializing } = useAuth();

  if (isInitializing) {
    return (
      <div className="app-loading">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  const isLoggedIn = !!(user && token);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={isLoggedIn ? '/portal' : '/login'} replace />}
        />

        <Route
          path="/login"
          element={isLoggedIn ? <Navigate to="/portal" replace /> : <Login />}
        />

        <Route
          path="/portal"
          element={isLoggedIn ? <Portal /> : <Navigate to="/login" replace />}
        />

        <Route
          path="/scoreboard"
          element={
            isLoggedIn ? <ScoreboardPage /> : <Navigate to="/login" replace />
          }
        />

        <Route
          path="*"
          element={<Navigate to={isLoggedIn ? '/portal' : '/login'} replace />}
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
